import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.hideScriptTypeSelector === false ? _c(VSelect, {
    staticClass: "my-2",
    attrs: {
      "items": [{
        text: 'Javascript',
        value: 'javascript'
      }, {
        text: 'Elixir',
        value: 'elixir'
      }, {
        text: 'URL Payload Parser',
        value: 'url'
      }],
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": [_vm.rules.required],
      "hide-details": "auto",
      "dense": "",
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.scriptTypeInternal,
      callback: function ($$v) {
        _vm.scriptTypeInternal = $$v;
      },
      expression: "scriptTypeInternal"
    }
  }) : _vm._e(), _vm._t("editor-before"), ['javascript', 'elixir'].includes(_vm.scriptTypeInternal) ? _c('codemirror-wrapper', {
    ref: "codemirror",
    attrs: {
      "options": _vm.cmOptions
    },
    on: {
      "focus": _vm.refreshCM
    },
    model: {
      value: _vm.scriptInternal,
      callback: function ($$v) {
        _vm.scriptInternal = $$v;
      },
      expression: "scriptInternal"
    }
  }) : _vm._e(), _vm._t("editor-after"), _vm.scriptTypeInternal === 'url' ? _c(VTextField, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": [_vm.rules.required],
      "label": _vm.$i18n_t('Core.ScriptEditor.editor.payloadParserUrl'),
      "placeholder": "http://",
      "hide-details": "auto",
      "autocomplete": "off",
      "required": "",
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.scriptInternal,
      callback: function ($$v) {
        _vm.scriptInternal = $$v;
      },
      expression: "scriptInternal"
    }
  }) : _vm._e(), _c(VForm, {
    ref: "testForm",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.evaluateScript.apply(null, arguments);
      }
    },
    model: {
      value: _vm.formIsValid,
      callback: function ($$v) {
        _vm.formIsValid = $$v;
      },
      expression: "formIsValid"
    }
  }, [_vm.hidePayloadInputs === false ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "0",
      "md": "3",
      "lg": "2"
    }
  }), _c(VCol, [_vm._v(_vm._s(_vm.$i18n_t('Core.ScriptEditor.tester.headline')))])], 1) : _vm._e(), _vm.hidePayloadInputs === false && !_vm.fixedPayloadType ? _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Core.ScriptEditor.tester.payloadType')) + "\n      ")]), _c(VCol, [_c(VSelect, {
    attrs: {
      "data-cy": "payload_type",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": [_vm.rules.required],
      "items": ['HEX', 'JSON'],
      "label": _vm.$i18n_t('Core.ScriptEditor.tester.payloadType'),
      "hide-details": "auto",
      "required": "",
      "readonly": _vm.readonly
    },
    on: {
      "change": _vm.validateForm
    },
    model: {
      value: _vm.payloadType,
      callback: function ($$v) {
        _vm.payloadType = $$v;
      },
      expression: "payloadType"
    }
  })], 1)], 1) : _vm._e(), _vm.hidePayloadInputs === false ? _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Core.ScriptEditor.tester.payload')) + "\n      ")]), _c(VCol, [_vm.actualPayloadType === 'HEX' ? _c(VTextField, {
    attrs: {
      "data-cy": "example_payload",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "error": !!_vm.payloadValidationError,
      "error-messages": _vm.payloadValidationError,
      "rules": [_vm.rules.required],
      "hide-details": "auto",
      "autocomplete": "off",
      "label": _vm.$i18n_t('Core.ScriptEditor.tester.payload'),
      "required": "",
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.payload,
      callback: function ($$v) {
        _vm.payload = $$v;
      },
      expression: "payload"
    }
  }) : _c(VTextarea, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "error": !!_vm.payloadValidationError,
      "error-messages": _vm.payloadValidationError,
      "rules": [_vm.rules.required],
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "autocomplete": "off",
      "label": _vm.$i18n_t('Core.ScriptEditor.tester.payload'),
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.payload,
      callback: function ($$v) {
        _vm.payload = $$v;
      },
      expression: "payload"
    }
  })], 1)], 1) : _vm._e(), _c('div', [_vm._t("additional-fields")], 2), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-play-circle",
      "disabled": !_vm.formIsValid,
      "type": "submit",
      "data-cy": "parse_btn",
      "loading": _vm.isParsing
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Core.ScriptEditor.tester.testButton')) + "\n        ")])], 1)], 1), _vm.showResult ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.$i18n_t('Core.ScriptEditor.tester.result')))]), _c('core-n20-card', {
    staticClass: "dt-card-text-01 payload"
  }, [typeof _vm.error === 'string' && _vm.error.trim() !== '' ? _c(VAlert, {
    staticClass: "mb-0",
    attrs: {
      "type": "error",
      "dense": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm.error && _vm.error !== null ? _c(VAlert, {
    staticClass: "mb-0",
    attrs: {
      "type": "error",
      "dense": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.error.name))]), _c('pre', [_vm._v(_vm._s(_vm.error.message))]), _c('br'), _c('br'), _vm._v("\n          Stack:\n          "), _c('pre', [_vm._v(_vm._s(_vm.error.stack))])]) : _c('json-viewer', {
    staticClass: "niotixJsonViewer",
    attrs: {
      "value": _vm.result,
      "expand-depth": 2,
      "copyable": "",
      "expanded": ""
    },
    scopedSlots: _vm._u([{
      key: "copy",
      fn: function () {
        return [_c('core-button', {
          staticStyle: {
            "right": "-20px"
          },
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-copy"
          },
          on: {
            "click": _vm.copySuccess
          }
        })];
      },
      proxy: true
    }], null, false, 3925558791)
  })], 1)], 1) : _vm._e(), _vm.logs && _vm.logs.length > 0 ? _c('div', {
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n_t('Core.ScriptEditor.tester.consoleOutput')))]), _c('div', {
    staticClass: "debug-logs"
  }, _vm._l(_vm.logs, function (log, index) {
    return _c('div', {
      key: `log_${index}`,
      style: _vm.logStyle(log)
    }, [_c('pre', [_vm._v(_vm._s(log))])]);
  }), 0)]) : _vm._e()], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };